// extracted by mini-css-extract-plugin
export default {"headRow":"f8NUYvoKSsbkAfDNFBXH"};